import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageCart = lazy(() => import("./layout/index"));

export const routerPageCart: RouterItemType = {
  path: "/store/cart",
  authorize: true,
  element: <LayoutPageCart />,
};
